import { useState } from 'react';
import { Link } from 'react-router-dom';
import Label from '../../components/label/label';
import Input from '../../components/input/input';
import Button from '../../components/button/button';
import PasswordInput from '../../components/passwordInput/passwordInput';
import { useLogin } from '../../hooks/useLogin';
import './login.css';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { handleSubmit: loginSubmit, forgotPassword } = useLogin();

    return (
        <div className='loginPageContainer'>
            <div className='loginCard'>
                <h1>Anmelden</h1>
                <form onSubmit={(e) => loginSubmit(e, email, password)} className='loginForm'>
                    <Label labelFor="email" labelValue="Email:" />
                    <br />
                    <Input
                        width='100%'
                        borderColor='black'
                        inputType="text"
                        inputId="email"
                        inputName="email"
                        inputValue={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <br />
                    <PasswordInput
                        labelFor='password'
                        labelValue='Passwort: '
                        inputId='password'
                        inputValue={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        width='100%'
                    />
                    <Input
                        borderColor='black'
                        inputType="submit"
                        inputId="submit"
                        inputName="submit"
                        inputValue="Anmelden"
                        height='50px'
                        width='100%'
                    />
                </form>
                <p>Du hast noch keinen Account?</p>
                <Link to="/register">
                    <Button buttonValue='Hier Account erstellen'  />
                </Link>
                <p>Du hast dein Passwort vergessen? Gib deine Email ein und klick unten.</p>
                <Button buttonValue='Passwort zurücksetzen' onClick={() => forgotPassword(email)} />
            </div>
        </div>
    );
}

export default Login;